import { render } from "./exchangeOrder.vue?vue&type=template&id=cd56fb5c&scoped=true"
import script from "./exchangeOrder.vue?vue&type=script&lang=js"
export * from "./exchangeOrder.vue?vue&type=script&lang=js"

import "./exchangeOrder.vue?vue&type=style&index=0&id=cd56fb5c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd56fb5c"]])

export default __exports__